import { render, staticRenderFns } from "./ActionConfigForm.vue?vue&type=template&id=354031be"
import script from "./ActionConfigForm.vue?vue&type=script&lang=js"
export * from "./ActionConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports